import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.parse-int.js";
import Protocol from './protocol';
import Bridge from './lib/WeishiBridge';
import env from '@tencent/vft-common/env';
import { AtomError } from './lib/error';
import { getPayVip as _getPayVip } from './lib/service';

if (env.isWeishi) {
  window.mqq = Bridge;
}

var SUPPORTED_API = {
  getAppInfo: 1,
  getDeviceInfo: 1,
  getMainUserInfo: 1,
  getVideoInfo: 1,
  replayVideo: 1,
  actionLogin: 1,
  openWebview: 1,
  close: 1,
  closeH5: 1,
  refreshWKcookie: 1,
  publishMsgToAllWebView: 1
};

if (!window.pageStateCallback) {
  // APP切后台台事件
  window.pageStateCallback = function (e) {
    if (e && e.data) {
      var event = e.data["function"] === 'onResume' ? 'onPageAppear' : 'onPageDisappear';
      Bridge.execEventCallback(event);
    }
  };
}
/**
 * Weishi JSBridge
 * 微视调用JSBridge，采用命名空间区分不同的权限，目前主要命名空间是 weishi、TencentVideo
 * @class WeishiJSBridge
 * @extends {Phone}
 */


var WeishiJSBridge = /*#__PURE__*/function (_Protocol) {
  _inherits(WeishiJSBridge, _Protocol);

  var _super = _createSuper(WeishiJSBridge);

  function WeishiJSBridge() {
    var _this;

    _classCallCheck(this, WeishiJSBridge);

    _this = _super.call(this);
    _this.name = 'WeishiJSBridge';
    return _this;
  }

  _createClass(WeishiJSBridge, [{
    key: "invoke",
    value: function invoke() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        timeout: 5000
      };

      // 兼容直接invoke的场景，可直接调用内部抹平方法
      if (typeof this[api] === 'function') {
        return this[api](params, options);
      }

      return this.call(api, params, options);
    }
    /**
     * 真正调用Bridge
     * @param {String} api
     * @param {Object} params
     * @param {Object} options
     * @returns
     */

  }, {
    key: "call",
    value: function call() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        timeout: 5000
      };
      return new Promise(function (resolve, reject) {
        var _ref = api.match(/^([a-z]+)\.([a-z]+)?/i) || ['', 'tenvideo', api],
            _ref2 = _slicedToArray(_ref, 3),
            namespace = _ref2[1],
            apiName = _ref2[2];

        console.log("[WeishiJSBridge] invoke ".concat(namespace, ".").concat(apiName, " params="), params);
        var timer;

        if (options.timeout > 0) {
          timer = setTimeout(function () {
            reject(new AtomError("[WeishiBridge] invoke '".concat(apiName, "' timeout ").concat(options.timeout, "ms")));
          }, options.timeout);
        }

        Bridge.invoke(namespace, apiName, params || {}, function (res) {
          console.log("[WeishiJSBridge] ".concat(apiName, " callback="), res);
          timer && clearTimeout(timer);

          if (res && parseInt(res.code, 10) === 0) {
            resolve(res.data, res);
          } else {
            reject(new AtomError("[WeishiJSBridge] inovke ".concat(apiName, " caught error \"").concat(res.msg, "(").concat(res.code, ")\""), res.code));
          }
        });
      });
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      if (env.isAndroid) {
        // 不设超时
        this.call('event.addEventListener', {
          event: event
        }, {
          timeout: 0
        }).then(callback);
      }

      Bridge.on(event, callback);
    }
    /**
     * 判断当前客户端版本是否支持指定 JS 接口
     * @param {Array} apiList - 接口列表
     * @returns {Promise}
     * @example <caption>Check availability of api `actionLogin` in iPad.</caption>
     * atom.checkApi(['actionLogin']).then(function(res) {
     *     console.log(JSON.stringify(res))
     * })
     */

  }, {
    key: "checkApi",
    value: function checkApi() {
      var apiList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var res = {};

      for (var i = 0; i < apiList.length; i++) {
        res[apiList[i]] = !!SUPPORTED_API[apiList[i]];
      }

      return Promise.resolve(res);
    }
  }, {
    key: "closeH5",
    value: function closeH5() {
      return this.close();
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      Bridge.dispatchEvent(event);
    }
  }, {
    key: "openLogin",
    value: function openLogin() {
      var _this2 = this;

      var params = {
        doLogin: true
      };

      if (env.isTenvideoUnion) {
        // 区分参数，原因是iOS未打通版本会因为加了这个参数后，导致无回调事件
        params.source = 'tenvideo';
      }

      return this.call('weishi.login', params, {
        timeout: 300000
      }).then(function (res) {
        _this2.postMessage('onActionLoginFinish', {
          errCode: 0,
          errMsg: ''
        }, {
          echo: true
        });

        return res;
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      return this.call('weishi.logout');
    }
  }, {
    key: "getAppInfo",
    value: function getAppInfo() {
      return this.call('getAppInfo');
    }
  }, {
    key: "getDeviceInfo",
    value: function getDeviceInfo() {
      return this.call('device.getDeviceInfo').then(function (res) {
        if (res) {
          res.isJBOS = res.isRoot;
        }

        return res;
      });
    }
  }, {
    key: "getMainUserInfo",
    value: function getMainUserInfo() {
      if (!env.isTenvideoUnion) {
        return _get(_getPrototypeOf(WeishiJSBridge.prototype), "getMainUserInfo", this).call(this, true);
      }

      return this.call('getMainUserInfo').then(function (res) {
        if (!res || !res.userInfo || res.type !== 'qq' && res.type !== 'wx') {
          return null;
        }

        return {
          headurl: res.userInfo.headImgUrl,
          nick: res.userInfo.nickname,
          type: res.type
        };
      });
    }
  }, {
    key: "openUrl",
    value: function openUrl(url) {
      if (url.match(/^weishi:\/\//)) {
        return this.openView(url);
      }

      return this.openView("weishi://webview?jump_url=".concat(encodeURIComponent(url)));
    }
  }, {
    key: "openView",
    value: function openView(url) {
      return this.call('weishi.openScheme', {
        scheme: url
      });
    }
  }, {
    key: "getPayVip",
    value: function getPayVip() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _getPayVip(param)["catch"](function (e) {
        console.error(e);
        return null;
      });
    }
  }, {
    key: "refreshVipInfo",
    value: function refreshVipInfo() {
      if (!env.isTenvideoUnion) {
        throw new AtomError('"refreshVipInfo" is not supported in this version!');
      }

      return this.call('refreshVipInfo');
    }
    /**
     * 关闭webview
     */

  }, {
    key: "close",
    value: function close() {
      return this.call('ui.popBack');
    }
    /**
     * 保存图片
     * @param {String} url - Base64地址
     */

  }, {
    key: "saveImage",
    value: function saveImage(url) {
      if (url && url.match(/^https?:\/\//)) {
        return Promise.reject(new Error('当前环境仅支持使用base64保存'));
      }

      return this.call('media.saveImage', {
        content: url
      });
    }
    /**
     * 全局推消息
     * 二次封装，抹平接口调用
     * @param {String} event - 事件名
     * @param {Object} params - 消息数据
     * @param {Object} options - 可选参数，echo: true|通知当前webview，bro
     * @param {Boolean} options.echo - true|通知当前webview，false|不通知当前页面
     * @param {Boolean} options.broadcast - true|广播所有页面，默认为true
     * @param {Array} options.domains - 通知的页面域名：['.qq.com']
     */

  }, {
    key: "postMessage",
    value: function postMessage() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.publishMsgToAllWebView({
        messageName: event,
        messageParams: params
      }, options);
    }
    /**
     * 全局推消息
     */

  }, {
    key: "publishMsgToAllWebView",
    value: function publishMsgToAllWebView() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$messageName = _ref3.messageName,
          messageName = _ref3$messageName === void 0 ? '' : _ref3$messageName,
          _ref3$messageParams = _ref3.messageParams,
          messageParams = _ref3$messageParams === void 0 ? {} : _ref3$messageParams;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      Bridge.dispatchEvent(messageName, messageParams, _objectSpread({
        echo: false,
        broadcast: true,
        domains: ['*.qq.com']
      }, options));
      return Promise.resolve({
        errCode: 0,
        errMsg: ''
      });
    }
  }]);

  return WeishiJSBridge;
}(Protocol);

export default new WeishiJSBridge();